import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { Table } from 'components'
import {
  CrudAction,
  Entity,
  usePageHeader,
  usePermissions,
} from '../../utils/hooks'
import useAdminService from '../../services/adminService'
import { RootState } from '../../store'
import { AdminEndpoint, adminTableColumns } from './adminColumns'
import { Container, TableWrapper } from './Admin.styled'

const Admin = () => {
  const { getDeliveriesNames } = useAdminService()
  const companyId = useSelector(
    (state: RootState) => state.user.profile?.company?.id
  )

  const { checkPermission } = usePermissions()
  const hasPermission = checkPermission(Entity.ADMIN, CrudAction.GET)
  const navigate = useNavigate()
  useEffect(() => {
    if (!hasPermission) {
      navigate('/')
    }
  }, [hasPermission])

  usePageHeader({
    headerTitle: 'Troubleshooting',
  })

  const mutation = useMutation(() => getDeliveriesNames(companyId), {
    onSuccess: (response) => {
      const blob = response.data as unknown as Blob
      const disposition = response.headers['content-disposition']

      const match = disposition?.match(/filename="?(.+)"?/)
      const filename = match ? match[1] : 'delivery_names.xlsx'

      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    onError: (err: { detail?: string }) => {
      toast.error(err?.detail ?? 'Failed to download file.')
    },
  })

  const endpoints: AdminEndpoint[] = [
    {
      id: '1',
      url: `admin/get_deliveries_names/${companyId}`,
      parameters: `company_id: ${companyId}`,
      onExecute: () => mutation.mutate(),
    },
  ]

  return (
    <Container>
      <TableWrapper>
        <Table
          data={endpoints}
          columns={adminTableColumns()}
          showPagination={false}
        />
      </TableWrapper>
    </Container>
  )
}

export default Admin
